const VideoModel = {
  created: "date",
  updated: "date",
}

export default VideoModel
